/* eslint-disable max-len */
import React from 'react';

const downArrow = (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16px" height="16px" viewBox="74 4 24 24" enableBackground="new 74 4 24 24">
    <path d="M74.6,9.7c0.2,0,0.3,0.1,0.4,0.2c3.6,3.6,8.2,8.3,10.9,11c2.8-2.7,8.3-8.2,11-11c0.3-0.3,0.5-0.3,0.8,0c0.3,0.3,0.3,0.5,0,0.8c-3.8,3.8-8.6,8.5-11.4,11.4c-0.1,0.1-0.3,0.2-0.4,0.2s-0.3-0.1-0.4-0.2c-3.8-3.8-8.5-8.5-11.3-11.4c-0.3-0.3-0.3-0.5-0.1-0.7C74.3,9.9,74.5,9.8,74.6,9.7z" />
  </svg>
);

const upArrow = (
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16px" height="16px" viewBox="74 4 24 24" enableBackground="new 74 4 24 24">
    <path d="M97.4,22.2c-0.2,0-0.3-0.1-0.4-0.2c-3.7-3.7-8.2-8.3-11-11c-2.8,2.8-8.3,8.3-11.1,11.1c-0.3,0.3-0.5,0.3-0.8,0c-0.2-0.3-0.2-0.6,0-0.8c3.8-3.8,8.6-8.5,11.5-11.4c0.1-0.1,0.2-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2c3.8,3.8,8.5,8.5,11.4,11.4c0.2,0.3,0.2,0.6,0,0.8C97.7,22.2,97.6,22.2,97.4,22.2z" />
  </svg>
);

const check = (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">
    <path d="M18.259 31.519l18.011-19.203c0.378-0.403 1.011-0.423 1.413-0.045s0.423 1.011 0.045 1.413l-18.759 20c-0.402 0.428-1.084 0.42-1.475-0.018l-7.241-8.106c-0.368-0.412-0.332-1.044 0.079-1.412s1.044-0.332 1.412 0.079l6.514 7.291z" />
  </svg>
);

module.exports = {
  downArrow,
  upArrow,
  check,
};
